import { postListFetcher } from '@/shared/api/list';
import { FormModalButton, type EntityField } from '@/shared/ui/list/EntityFormModal';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { saveCarTag } from './api';

const LIST_KEY = 'car-tags';

interface CarTag extends ListRow {
  id: number;
  name?: string;
  title?: string;
}

const FIELDS: EntityField[] = [{ name: 'title', label: 'Название', placeholder: 'Название...' }];

const config: ListPageConfig<CarTag> = {
  queryKey: LIST_KEY,
  title: 'Справочник авто',
  boxTitle: 'Теги',
  errorText: 'Ошибка загрузки тегов',
  fetchList: postListFetcher('/car/tag/list/'),
  rows: ['list'],
  searchKeys: [
    { value: 'id', label: 'Поиск по id' },
    { value: 'title', label: 'Поиск по тегу' },
  ],
  headerActions: (
    <FormModalButton
      buttonLabel="Создать"
      buttonClassName="btn btn-info pull-right"
      title="Создать тег"
      fields={FIELDS}
      initial={{ title: '' }}
      save={(v) => saveCarTag(undefined, String(v.title))}
      listKey={LIST_KEY}
    />
  ),
  columns: [
    { header: 'id', sortField: 'id', render: (tag) => tag.id },
    { header: 'Теги', sortField: 'name', render: (tag) => tag.name ?? tag.title },
    {
      header: 'Edit',
      render: (tag) => (
        <FormModalButton
          buttonLabel="Edit"
          title="Редактировать тег"
          fields={FIELDS}
          initial={{ title: String(tag.name ?? tag.title ?? '') }}
          save={(v) => saveCarTag(tag.id, String(v.title))}
          listKey={LIST_KEY}
        />
      ),
    },
  ],
};

export const CarTagsPage = () => <GenericListPage config={config} />;
